(() => {
  const page = document.querySelector('[data-password-page]');
  const toggle = document.querySelector('[data-password-toggle]');
  const panel = document.querySelector('[data-password-panel]');
  const close = document.querySelector('[data-password-close]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!page || !toggle || !panel) return;

  const primeAutoplayVideo = (videoElement) => {
    if (!videoElement) return;

    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.autoplay = true;
    videoElement.loop = true;
    videoElement.playsInline = true;
    videoElement.controls = false;
    videoElement.disablePictureInPicture = true;
    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('autoplay', '');
    videoElement.setAttribute('loop', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');
    videoElement.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    videoElement.setAttribute('disablepictureinpicture', '');
    videoElement.removeAttribute('controls');

    const playVideo = () => {
      if (document.visibilityState === 'hidden' || videoElement.readyState < 2) return;
      const playAttempt = videoElement.play();
      if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(() => {});
    };

    videoElement.addEventListener('loadeddata', playVideo, { once: true });
    videoElement.addEventListener('canplay', playVideo, { once: true });
    window.addEventListener('pageshow', playVideo);
    document.addEventListener('visibilitychange', playVideo);
    ['pointerdown', 'touchstart', 'click'].forEach((eventName) => {
      document.addEventListener(eventName, playVideo, { once: true, passive: true });
    });

    playVideo();
  };

  [...document.querySelectorAll('[data-jsca-autoplay-video], .jsca-password__video')].forEach(primeAutoplayVideo);

  // Design decision: progressive enhancement only. If JS fails, Shopify's forms still render;
  // this script only turns private password access into a cinematic archive panel.
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let previousFocus = null;

  const getFocusable = () => [...panel.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);

  const openPanel = ({ focusPassword = true } = {}) => {
    previousFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    window.setTimeout(() => {
      const error = panel.querySelector('.jsca-password__form-message--error');
      const passwordInput = panel.querySelector('input[type="password"]');
      const first = (focusPassword && passwordInput) || error || getFocusable()[0];
      if (first) first.focus({ preventScroll: true });
    }, reduceMotion ? 0 : 120);
  };

  const closePanel = () => {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  };

  panel.setAttribute('aria-hidden', 'true');
  toggle.addEventListener('click', () => openPanel());
  if (close) close.addEventListener('click', closePanel);

  panel.addEventListener('click', (event) => {
    if (event.target === panel) closePanel();
  });

  document.addEventListener('keydown', (event) => {
    if (!panel.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closePanel();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (panel.querySelector('.jsca-password__form-message--error')) {
    openPanel({ focusPassword: false });
  }
})();
